import { forwardRef, type Ref, type SVGProps } from "react";

function SvgIntroductionVideo(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.5 15.5C5.72137 12.9771 7.48588 11 10 11C12.5141 11 14.2786 12.9771 14.5 15.5M12.5 7C12.5 8.38071 11.3807 9.5 10 9.5C8.61929 9.5 7.5 8.38071 7.5 7C7.5 5.61929 8.61929 4.5 10 4.5C11.3807 4.5 12.5 5.61929 12.5 7ZM17 3.5C17 3.77614 16.7761 4 16.5 4C16.2239 4 16 3.77614 16 3.5C16 3.22386 16.2239 3 16.5 3C16.7761 3 17 3.22386 17 3.5ZM2.5 15.5H17.5C18.6046 15.5 19.5 14.6046 19.5 13.5V2.5C19.5 1.39543 18.6046 0.5 17.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V13.5C0.5 14.6046 1.39543 15.5 2.5 15.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgIntroductionVideo);
export default ForwardRef;
